export function buyerAdvisoryResidentialCP826() {
return [   // Release 2026-09-02 12:04:40
 
{
   page: 0,
   name: "Agent Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 156.84,
   width: 383.64,
   height: 10.08
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 173.236,
   left: 180.12,
   width: 356.28,
   height: 12.044
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.36,
   height: 10.08
}
,
{
   page: 0,
   name: "Buyer Broker and CoAgent Names", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 199.474,
   left: 180.12,
   width: 356.28,
   height: 12.043
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 19", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 226.656,
   left: 180.12,
   width: 356.28,
   height: 12.043
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 156.84,
   width: 383.64,
   height: 10.08
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.36,
   height: 10.08
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name 5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 156.84,
   width: 383.64,
   height: 10.08
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name 6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.36,
   height: 10.08
}
,
{
   page: 3,
   name: "Agent Brokerage Firm Name 7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 156.84,
   width: 383.64,
   height: 10.08
}
,
{
   page: 3,
   name: "Agent Brokerage Firm Name 8", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.36,
   height: 10.08
}
,
{
   page: 4,
   name: "Agent Brokerage Firm Name 9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 156.84,
   width: 383.64,
   height: 10.08
}
,
{
   page: 4,
   name: "Agent Brokerage Firm Name 10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.36,
   height: 10.08
}
,
{
   page: 5,
   name: "Agent Brokerage Firm Name 11", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 156.84,
   width: 383.64,
   height: 10.08
}
,
{
   page: 5,
   name: "Agent Brokerage Firm Name 12", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.36,
   height: 10.08
}
,
{
   page: 6,
   name: "Agent Brokerage Firm Name 13", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 156.84,
   width: 383.64,
   height: 10.08
}
,
{
   page: 6,
   name: "Agent Brokerage Firm Name 14", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.36,
   height: 10.08
}
,
{
   page: 7,
   name: "Agent Brokerage Firm Name 15", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 156.84,
   width: 383.64,
   height: 10.08
}
,
{
   page: 7,
   name: "Agent Brokerage Firm Name 16", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.36,
   height: 10.08
}
,
{
   page: 8,
   name: "Agent Brokerage Firm Name 17", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 47.4,
   left: 156.84,
   width: 383.64,
   height: 11.16
}
,
{
   page: 8,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 338.375,
   left: 72.6545,
   width: 378.2405,
   height: 15.709
}
,
{
   page: 8,
   name: "Date Signature Buyer Broker", 
   fontSize: 9,
   type: "date",
   top: 338.375,
   left: 455.935,
   width: 76.680,
   height: 15.709
}
,
{
   page: 8,
   name: "Signature Buyer CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 386.735,
   left: 72.6545,
   width: 378.2405,
   height: 15.709
}
,
{
   page: 8,
   name: "Date Signature Buyer CoAgent", 
   fontSize: 9,
   type: "date",
   top: 386.735,
   left: 455.935,
   width: 76.680,
   height: 15.709
}
,
{
   page: 8,
   name: "Agent Brokerage Firm Name 18", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 743.8255,
   left: 73.08,
   width: 300.36,
   height: 10.0800
}
] }
